import { render } from "./NotFoundPage.vue?vue&type=template&id=3a369bf2&scoped=true&ts=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"

import "./NotFoundPage.vue?vue&type=style&index=0&id=3a369bf2&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a369bf2"]])

export default __exports__